/* -------------------------------------------------------- */

html,
body {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

body {
  padding: var(--body-padding);
  background-color: var(--background-color);
  font-family: var(--font-family), Figtree, sans-serif;
  font-size: var(--font-size);
  line-height: 1.3;
  color: var(--primary-color);
}

h1,
h2,
h3 {
  margin: 0;

  &:nth-child(n + 2) {
    margin-top: 0.5em;
  }
}

h1 {
  font-size: 2em;
}

h2 {
  font-size: 1.5em;
}

h3 {
  font-size: 1em;
}

p {
  margin: 0;

  &:nth-child(n + 2) {
    margin-top: 0.5em;
  }
}

/* ------------- SKELETON ------------- */

@keyframes skeleton {
  0% {
    background-color: #e5e5e5;
  }
  100% {
    background-color: #f5f5f5;
  }
}

.SkeletonImage {
  aspect-ratio: 16 / 9;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  background-color: #e5e5e5;
  animation: skeleton 1s linear infinite alternate;
  font-size: 2em;
  line-height: 0;
}

.SkeletonImage[data-format='16:9_LARGE'],
.SkeletonImage[data-format='16:9_MEDIUM'],
.SkeletonImage[data-format='16:9_SMALL'] {
  aspect-ratio: 16 / 9;
}

.SkeletonImage[data-format='4:3_LARGE'],
.SkeletonImage[data-format='4:3_MEDIUM'],
.SkeletonImage[data-format='4:3_SMALL'] {
  aspect-ratio: 4 / 3;
}

.SkeletonImage[data-format='1:1_LARGE'],
.SkeletonImage[data-format='1:1_MEDIUM'],
.SkeletonImage[data-format='1:1_SMALL'] {
  aspect-ratio: 1;
}

/* ------------- COMPONENTS ------------- */

.WidgetHeader {
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  align-items: center;
  gap: 16px;
  margin-bottom: 25px;
  width: 100%;
}

@media (max-width: 900px) {
  .WidgetHeader {
    &.WidgetHeader--Table {
      flex-direction: column;
      align-items: flex-start;

      .Search:nth-child(2) {
        width: 100%;
        max-width: 100%;
      }
    }
  }
}

@media (max-width: 900px) {
  .WidgetHeader {
    &.WidgetHeader--Events {
      flex-wrap: wrap;

      .WidgetHeaderHeadline {
        flex: auto;
        width: 100%;
      }

      .Search:nth-child(2):not(:last-child) {
        width: 50%;
        max-width: 50%;
      }

      .Search:last-child {
        width: 100%;
        max-width: 100%;
      }

      .Event:nth-child(3) {
        width: 50%;
        max-width: 50%;
      }

      .Event:nth-child(2):last-child {
        width: 100%;
        max-width: 100%;
      }
    }
  }
}

@media (min-width: 1500px) {
  .WidgetHeader.WidgetHeader--Grid--Masonry {
    grid-template-columns: repeat(4, minmax(0px, 1fr)) !important;

    & .WidgetHeaderHeadline {
      grid-column: span 3;
    }
  }
}

.WidgetFooter {
  display: flex;
  flex-wrap: nowrap;
  align-items: center;
  justify-content: flex-end;
  gap: 16px;
  margin-top: 25px;
  width: 100%;
}

.WidgetFooter--Grid,
.WidgetFooter--Events {
  justify-content: center;
}

.LoadMoreButton {
  cursor: pointer;
  padding: 8px 16px;
  background-color: var(--primary-color);
  border-radius: var(--grid-item-border-radius);
  color: var(--background-color);
}

.WidgetHeaderHeadline {
  flex: 1;

  & h1 {
    margin: 0;

    font-size: 1.6em;
  }
}

.Search {
  position: relative;

  display: flex;
  flex-wrap: nowrap;
  align-items: center;
  flex: 1;
  position: relative;
  width: 50%;
  max-width: 200px;

  & .SearchInput {
    display: block;
    /*padding: var(--table-cell-padding) var(--table-cell-padding) var(--table-cell-padding) 40px;
    width: calc(300px - (var(--table-cell-padding) + 40px + 2px));*/

    padding: 10px 10px 10px 40px;
    width: 100%;

    border: 1px solid var(--border-color);
    border-radius: var(--table-border-radius);
    outline: none;
    background-color: #fff;
    font-family: var(--font-family), Figtree, sans-serif;
    font-size: var(--font-size);
    color: var(--primary-color);

    &:hover {
      border-color: var(--primary-color);
    }

    &:focus {
      border-color: var(--primary-color);
      color: var(--primary-color);
    }
  }

  &::after {
    content: '';
    pointer-events: none;
    position: absolute;
    top: 50%;
    left: 15px;
    display: inline-block;
    transform: translate3d(0, -50%, 0);

    font-family: 'Font Awesome 6 Pro';
    font-weight: 900;
    font-style: normal;
    font-variant: normal;
    text-rendering: auto;
    -webkit-font-smoothing: antialiased;
  }
}

.WidgetHeader--Table {
  .Search {
    & .SearchInput {
      border-radius: var(--table-border-radius);
    }
  }
}

.WidgetHeader--Grid {
  .Search {
    & .SearchInput {
      border-radius: var(--grid-item-border-radius);
    }
  }
}

.WidgetHeader--Grid {
  display: grid;
  grid-template-columns: repeat(3, minmax(0px, 1fr));
  grid-column-gap: var(--grid-item-gap);
  grid-row-gap: var(--grid-item-gap);

  .WidgetHeaderHeadline {
    grid-column: span 2;
  }

  .Search {
    width: 100%;
    max-width: 100%;

    & .SearchInput {
      border-radius: var(--grid-item-border-radius);
    }
  }

  @media only screen and (max-width: 899px) {
    .Search {
      grid-column: span 2;
    }
  }

  @media only screen and (min-width: 0px) {
    grid-template-columns: repeat(1, minmax(0, 1fr)) !important;

    .WidgetHeaderHeadline {
      grid-column: span 1;
    }
  }

  @media only screen and (min-width: 600px) {
    grid-template-columns: repeat(2, minmax(0, 1fr)) !important;

    .WidgetHeaderHeadline {
      grid-column: span 2;
    }
  }

  @media only screen and (min-width: 900px) {
    grid-template-columns: repeat(3, minmax(0, 1fr)) !important;

    .WidgetHeaderHeadline {
      grid-column: span 2;
    }
  }

  @media only screen and (min-width: 1200px) {
    grid-template-columns: repeat(4, minmax(0, 1fr)) !important;

    .WidgetHeaderHeadline {
      grid-column: span 3;
    }
  }

  @media only screen and (min-width: 1500px) {
    grid-template-columns: repeat(5, minmax(0, 1fr)) !important;

    .WidgetHeaderHeadline {
      grid-column: span 4;
    }
  }

  @media only screen and (min-width: 1800px) {
    grid-template-columns: repeat(6, minmax(0, 1fr)) !important;

    .WidgetHeaderHeadline {
      grid-column: span 5;
    }
  }

  @media only screen and (min-width: 2100px) {
    grid-template-columns: repeat(7, minmax(0, 1fr)) !important;

    .WidgetHeaderHeadline {
      grid-column: span 6;
    }
  }

  @media only screen and (min-width: 2400px) {
    grid-template-columns: repeat(8, minmax(0, 1fr)) !important;

    .WidgetHeaderHeadline {
      grid-column: span 7;
    }
  }
}

.WidgetHeader--Events {
  .Search {
    & .SearchInput {
      border-radius: var(--events-item-border-radius);
    }
  }
}

@media only screen and (max-width: 640px) {
  .Search {
    width: 100%;

    & .SearchInput {
      width: calc(100% - (var(--table-cell-padding) + 40px + 2px));
    }
  }

  .WidgetHeader--Table,
  .WidgetHeader--Grid {
    .Search {
      max-width: 100%;
    }
  }
}

.Event,
.Filter {
  display: flex;
  flex-wrap: nowrap;
  align-items: center;
  flex: 1;
  position: relative;
  width: 50%;
  max-width: 200px;

  & .EventSelect,
  & .FilterSelect {
    cursor: pointer;
    -webkit-appearance: none;
    appearance: none;
    position: relative;
    border: 1px solid var(--border-color);
    border-radius: var(--events-item-border-radius);
    outline: none;
    /*padding: var(--table-cell-padding) 35px var(--table-cell-padding) var(--table-cell-padding);*/
    padding: 10px 35px 10px 15px;
    width: 100%;
    font-family: var(--font-family), Figtree, sans-serif;
    font-size: var(--font-size);
    color: var(--primary-color);

    &:hover {
      border-color: var(--primary-color);
    }

    &:focus {
      border-color: var(--primary-color);
    }
  }

  &::after {
    content: '';
    pointer-events: none;
    position: absolute;
    top: 50%;
    right: 15px;
    display: inline-block;
    margin-left: 15px;
    transform: translate3d(0, -50%, 0);

    font-family: 'Font Awesome 6 Pro';
    font-weight: 900;
    font-style: normal;
    font-variant: normal;
    text-rendering: auto;
    -webkit-font-smoothing: antialiased;
  }
}

.Event {
  margin-left: auto;
}

.WidgetHeader--Table .FilterSelect {
  border-radius: var(--table-border-radius);
}

.WidgetHeader--Grid .Filter {
  width: 100%;
  max-width: 100%;

  & .FilterSelect {
    border-radius: var(--grid-item-border-radius);
  }
}

@media (max-width: 900px) {
  .WidgetHeader--Table .Filter {
    width: 100%;
    max-width: 100%;
  }
}

@media only screen and (max-width: 640px) {
  .Filter {
    width: 100%;
    max-width: 100%;
  }

  .WidgetHeader--Grid .Filter {
    grid-column: span 2; /* Fix mobile display */
  }

  .WidgetHeader--Events .Search,
  .WidgetHeader--Events .Event,
  .WidgetHeader--Events .Filter {
    flex: auto;
    width: 100% !important;
    max-width: 100% !important;
  }
}

.PaginationWrapper {
  display: flex;
  flex-wrap: nowrap;
  align-items: center;
  gap: 16px;
  flex: 0;
}

.Pagination {
  display: flex;
  flex-wrap: nowrap;
  align-items: center;
  flex: 0;
  position: relative;
  width: 100%;
  border: 1px solid var(--border-color);
  border-radius: var(--table-border-radius);
  background-color: #fff;

  & .PaginationButton {
    cursor: pointer;
    position: relative;
    padding: var(--table-cell-padding) calc(var(--table-cell-padding) + 5px);
    outline: none;
    border: none;
    background-color: #fff;
    font-family: var(--font-family), Figtree, sans-serif;
    font-size: var(--font-size);
    color: var(--primary-color);

    &:first-of-type {
      border-top-left-radius: var(--table-border-radius);
      border-bottom-left-radius: var(--table-border-radius);
    }

    &:last-of-type {
      border-top-right-radius: var(--table-border-radius);
      border-bottom-right-radius: var(--table-border-radius);
    }

    &:nth-child(n + 2) {
      border-left: 1px solid var(--border-color);
    }

    &:hover {
      z-index: 100;
      background-color: var(--table-hover-color);
      border-color: var(--primary-color) !important;

      &:not(:first-of-type) + .PaginationButton {
        border-color: var(--primary-color) !important;
      }

      &:not(:first-of-type) + .PaginationButton--Active {
        border-color: var(--primary-color) !important;
      }

      &:not(:first-of-type):not(:last-of-type)::before {
        content: '';
        position: absolute;
        top: -1px;
        right: -1px;
        left: -1px;
        height: 1px;
        background-color: var(--primary-color);
      }

      &:not(:first-of-type):not(:last-of-type)::after {
        content: '';
        position: absolute;
        right: -1px;
        bottom: -1px;
        left: -1px;
        height: 1px;
        background-color: var(--primary-color);
      }

      &:last-of-type {
        border-color: var(--border-color) !important;
      }
    }

    &.PaginationButton--Active {
      pointer-events: none;
      position: relative;
      background-color: var(--table-hover-color);

      &::before {
        content: '';
        position: absolute;
        top: -1px;
        right: -1px;
        left: -1px;
        height: 1px;
        background-color: var(--border-color);
      }

      &::after {
        content: '';
        position: absolute;
        right: -1px;
        bottom: -1px;
        left: -1px;
        height: 1px;
        background-color: var(--border-color);
      }
    }

    &.PaginationButton--Active + .PaginationButton {
      border-color: var(--border-color);
    }
  }
}

.Items {
  display: flex;
  flex-wrap: nowrap;
  align-items: center;
  flex: 0;
  position: relative;

  & .ItemsSelect {
    cursor: pointer;
    -webkit-appearance: none;
    appearance: none;
    position: relative;
    border: 1px solid var(--border-color);
    border-radius: var(--table-border-radius);
    outline: none;
    padding: var(--table-cell-padding) 35px var(--table-cell-padding) var(--table-cell-padding);
    font-family: var(--font-family), Figtree, sans-serif;
    font-size: var(--font-size);
    color: var(--primary-color);

    &:hover {
      border-color: var(--primary-color);
    }

    &:focus {
      border-color: var(--primary-color);
    }
  }

  &::after {
    content: '';
    pointer-events: none;
    position: absolute;
    top: 50%;
    right: 15px;
    display: inline-block;
    margin-left: 15px;
    transform: translate3d(0, -50%, 0);

    font-family: 'Font Awesome 6 Pro';
    font-weight: 900;
    font-style: normal;
    font-variant: normal;
    text-rendering: auto;
    -webkit-font-smoothing: antialiased;
  }
}

/* ---------------------------
  TABLE
--------------------------- */

.table {
  overflow: auto;
  /*height: 200px;*/ /* ----> SET FIXED HEIGHT HERE */
  border: 1px solid var(--border-color);
  border-radius: var(--table-border-radius);
  background-color: #fff;

  & table {
    width: 100%;

    border-collapse: collapse;
    border-spacing: 0px;
  }

  & tbody {
    & tr {
      & td {
        & .spanholder--label {
          & span {
            &.numbers {
              justify-content: flex-start;
            }
          }
        }

        & span {
          display: flex;
          align-items: center;
          justify-content: flex-start;
          gap: 8px;
          white-space: nowrap;

          &.numbers {
            justify-content: flex-end;
          }

          &.long_text {
            display: inline-block;
            white-space: normal;
            min-width: 300px;

            &.wrap {
              white-space: pre;
              min-width: 0px;
            }
          }

          &.rating {
            gap: 1px;
          }

          &.image {
            line-height: 0;

            & a {
              border: 0 !important;
            }

            & img {
              width: auto;
              height: 18px;
            }
          }

          /* GROUP_START */

          &.status {
            gap: 4px;

            & strong {
              padding: 0.5em 1.2em;
              border: 1px solid var(--primary-color);
              border-radius: 1.5em;
              font-size: 0.7em;
              font-weight: normal;
            }

            &.empty {
              & strong {
                opacity: 0;
              }
            }
          }

          &.dropdown,
          &.tags {
            gap: 4px;

            & strong {
              padding: 0.5em 1.2em;
              border: 1px solid var(--primary-color);
              border-radius: 1.5em;
              font-size: 0.7em;
              font-weight: normal;
            }

            &.empty {
              & strong {
                opacity: 0;
              }
            }
          }

          &.group {
            gap: 4px;

            & strong {
              padding: 0.5em 1.2em;
              border: 1px solid var(--primary-color);
              border-radius: 1.5em;
              font-size: 0.7em;
              font-weight: normal;
            }

            &.empty {
              & strong {
                opacity: 0;
              }
            }
          }

          &.timeline {
            gap: 4px;

            & strong {
              padding: 0.5em 1.2em;
              border: 1px solid var(--primary-color);
              border-radius: 1.5em;
              font-size: 0.7em;
              font-weight: normal;
            }

            &.empty {
              & strong {
                opacity: 0;
              }
            }
          }

          &.vote {
            gap: 4px;

            & strong {
              padding: 0.5em 1.2em;
              border: 1px solid var(--primary-color);
              border-radius: 1.5em;
              font-size: 0.7em;
              font-weight: normal;
            }

            &.empty {
              & strong {
                opacity: 0;
              }
            }
          }

          &.week {
            gap: 4px;

            & strong {
              padding: 0.5em 1.2em;
              border: 1px solid var(--primary-color);
              border-radius: 1.5em;
              font-size: 0.7em;
              font-weight: normal;
            }

            &.empty {
              & strong {
                opacity: 0;
              }
            }
          }

          /* GROUP_END */
        }
      }
    }
  }

  & thead {
    & tr {
      z-index: 100;
      position: sticky;
      top: 0;

      &::after {
        content: '';
        position: absolute;
        right: 0;
        bottom: 0px;
        left: 0;
        height: 1px;
        background-color: var(--border-color);
      }

      & th {
        padding: 0;
        background-color: #fff;
        font-weight: bold;
        text-align: left;

        &:nth-child(n + 2) {
          border-left: 1px solid var(--border-color);
        }
      }
    }

    & .column_header {
      cursor: pointer;
      display: flex;
      flex-wrap: nowrap;
      align-items: center;
      gap: 14px;
      padding: var(--table-cell-padding) calc(var(--table-cell-padding) + (var(--table-cell-padding) / 2));

      &:hover {
        background-color: var(--table-hover-color);
      }

      & .label {
        flex: 1;
        padding: 2px 0;
        white-space: nowrap;
      }

      & .icon {
        flex: 0;
        font-size: 0.8em;
      }
    }
  }

  & tbody {
    box-shadow: 0 4px 6px -4px rgba(0, 0, 0, 0.1);

    & tr {
      border-bottom: 1px solid var(--border-color);

      &:last-of-type {
        border-bottom: none;
      }

      & td {
        padding: var(--table-cell-padding) calc(var(--table-cell-padding) + (var(--table-cell-padding) / 2));
        text-align: left;

        &:nth-child(n + 2) {
          border-left: 1px solid var(--border-color);
        }

        & a {
          border-top: 1px solid transparent !important;
          border-bottom: 1px solid transparent;
          text-decoration: none;
          color: var(--primary-color);

          &:hover {
            border-color: var(--secondary-color);
            color: var(--secondary-color);
          }
        }

        .spanholder--label {
          margin-top: 0;
        }

        .downloads--thumbs {
          flex-wrap: nowrap;
        }
      }
    }

    & tr.main--item[data-zebra='even'] {
      & td {
        background-color: var(--table-hover-color);
      }
    }
    /*
    & tr.main--item[data-zebra="even"] + tr.subitems-row > td {
      background-color: var(--table-hover-color);
    }
*/
  }

  & tfoot {
    & tr {
      & th {
        padding: var(--table-cell-padding);
        text-align: left;

        &:empty {
          display: none;
        }
      }
    }
  }

  &.content-alignment-left {
    & tbody {
      & tr {
        & td {
          & .spanholder {
            text-align: left;
          }

          & span {
            justify-content: flex-start;

            &.text,
            &.long_text {
              text-align: left;
            }

            &.long_text {
              &.wrap {
                white-space: pre;
                min-width: 0px;
              }
            }
          }

          & .spanholder--label {
            text-align: left;
          }
        }
      }
    }
  }

  &.content-alignment-center {
    & tbody {
      & tr {
        & td {
          & .spanholder {
            text-align: center;
          }

          & span {
            justify-content: center;

            &.text,
            &.long_text {
              text-align: center;
            }

            &.long_text {
              &.wrap {
                white-space: pre;
                min-width: 0px;
              }
            }
          }

          & .spanholder--label {
            text-align: center;
          }
        }
      }
    }
  }

  &.content-alignment-right {
    & tbody {
      & tr {
        & td {
          & .spanholder {
            text-align: right;
          }

          & span {
            justify-content: flex-end;

            &.text,
            &.long_text {
              text-align: right;
            }

            &.long_text {
              &.wrap {
                white-space: pre;
                min-width: 0px;
              }
            }
          }

          & .spanholder--label {
            text-align: right;
          }
        }
      }
    }
  }
}

.table {
  & tbody {
    &.subitems-active {
      & tr {
        &:nth-child(2n) {
          & td {
            /*background-color: transparent;*/
          }
        }
        &.subitems-current {
          & td {
            /*background-color: var(--table-hover-color) !important;*/
          }
        }
      }
    }

    & tr.subitems-row {
      & > td {
        padding: calc(var(--table-cell-padding) * 2);
        background-color: transparent !important;

        & .subitems-table {
          overflow: auto;
          display: inline-block;
          width: auto;

          border: 1px solid var(--border-color);
          border-radius: var(--table-border-radius);
          background-color: var(--background-color);

          & > table {
            width: 100%;

            & th {
              pointer-events: none;
            }

            & td {
              background-color: transparent !important;
            }

            & th,
            & td {
              width: 0;

              white-space: nowrap;
            }
          }
        }
      }
    }
  }
}

.subitems-trigger {
  cursor: pointer;
  min-width: 10px;
  max-width: 10px;
  width: 0;

  text-align: center !important;
}

.subitems-trigger--active i {
  transform: rotate(90deg);
}

@media (hover: hover) {
  .subitems-trigger {
    &:hover {
      /*background-color: var(--table-hover-color);*/

      & i {
        transform: rotate(90deg);
      }
    }
  }
}

/* ---------------------------
  GRID
--------------------------- */

.grid {
  & .grid--masonry {
    align-items: start;
    grid-column-gap: var(--grid-item-gap);
  }

  & .grid--grid {
    grid-column-gap: var(--grid-item-gap);
    grid-row-gap: var(--grid-item-gap);
  }

  & .grid--grid {
    @media only screen and (min-width: 0px) {
      grid-template-columns: repeat(1, minmax(0, 1fr)) !important;
    }

    @media only screen and (min-width: 600px) {
      grid-template-columns: repeat(2, minmax(0, 1fr)) !important;
    }

    @media only screen and (min-width: 900px) {
      grid-template-columns: repeat(3, minmax(0, 1fr)) !important;
    }

    @media only screen and (min-width: 1200px) {
      grid-template-columns: repeat(4, minmax(0, 1fr)) !important;
    }

    @media only screen and (min-width: 1500px) {
      grid-template-columns: repeat(5, minmax(0, 1fr)) !important;
    }

    @media only screen and (min-width: 1800px) {
      grid-template-columns: repeat(6, minmax(0, 1fr)) !important;
    }

    @media only screen and (min-width: 2100px) {
      grid-template-columns: repeat(7, minmax(0, 1fr)) !important;
    }

    @media only screen and (min-width: 2400px) {
      grid-template-columns: repeat(8, minmax(0, 1fr)) !important;
    }
  }

  & .grid--masonry_column {
    row-gap: var(--grid-item-gap);
  }

  & .grid--wrapper {
    list-style: none;
    display: grid;
    grid-template-columns: repeat(3, minmax(0, 1fr));
    gap: var(--grid-item-gap);
    margin: 0;
    padding: 0;
  }

  .grid--item {
    overflow: hidden;
    border: 1px solid var(--border-color);
    border-radius: var(--grid-item-border-radius);
    background-color: #fff; /*var(--widget-background-color);*/

    & .downloads--list {
      & li {
        overflow: hidden;
        max-width: 100%;

        & span.value {
          max-width: inherit;
          overflow: hidden;

          text-overflow: ellipsis;
          white-space: nowrap;

          & a {
            flex: 1;
            overflow: hidden;
            border-bottom: 0 !important;

            text-overflow: ellipsis;
            white-space: nowrap;

            & .file-name {
              overflow: hidden;
              margin-top: 0 !important;
              border-bottom: 1px solid transparent;

              padding-bottom: 1px;
              line-height: 1.4;

              text-overflow: ellipsis;
              white-space: nowrap;
            }

            &:hover {
              border-color: transparent !important;

              & .file-name {
                border-color: var(--secondary-color);
              }
            }
          }
        }
      }
    }
  }

  & a {
    border-bottom: 1px solid transparent;
    text-decoration: none;
    color: var(--primary-color);

    &:hover {
      border-color: var(--secondary-color);
      color: var(--secondary-color);
    }
  }

  & .card-content {
    padding: var(--grid-item-padding);

    & > div {
      &:nth-child(n + 2) {
        & span {
          margin-top: 0.75em; /* 0.3em */

          &.image {
            margin-top: 1em;
            margin-bottom: 1em;
          }
        }
      }
    }
  }

  & .card-gallery .card-image {
    position: relative;
  }

  & .card-image {
    overflow: hidden;
    background-color: var(--border-color);
    line-height: 0;

    & img {
      width: 100%;
      height: auto;
    }

    @media (hover: hover) {
      &:hover {
        & .gallery-arrow {
          display: flex;
        }
      }
    }
  }

  & .gallery-arrow {
    cursor: pointer;
    -webkit-appearance: none;
    appearance: none;
    position: absolute;
    top: 0;
    display: none;
    align-items: center;
    justify-content: center;
    margin: 0;
    padding: 0;
    width: 100px;
    height: 100%;
    border: none;
    background: transparent;

    font-size: 1.5em;
    color: #fff;

    & i {
      position: relative;
    }

    &.gallery-arrow-prev,
    &.gallery-arrow-next {
      &:before {
        content: '';
        position: absolute;
        inset: 0;
        display: block;
        width: 100%;
        height: 100%;
        opacity: 0;
        transition: opacity 0.2s ease-out;
      }
    }

    &.gallery-arrow-prev {
      left: 0;
      justify-content: flex-start;
      padding-left: 40px;

      &:before {
        content: '';
        background: linear-gradient(90deg, rgba(0, 0, 0, 0.5) 0%, rgba(0, 0, 0, 0) 100%);
      }
    }

    &.gallery-arrow-next {
      right: 0;
      justify-content: flex-end;
      padding-right: 40px;

      &:before {
        content: '';
        background: linear-gradient(90deg, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0.5) 100%);
      }
    }

    @media (hover: hover) {
      &:hover {
        &::before {
          opacity: 1;
        }
      }
    }
  }

  & .card-thumbnails {
    display: grid;
    grid-template-columns: repeat(6, minmax(30px, 1fr));
    gap: 4px;
    padding: var(--grid-item-padding);
    padding-bottom: 0;
  }

  & .card-thumbnails button {
    cursor: pointer;
    -webkit-appearance: none;
    appearance: none;
    position: relative;
    display: inline-block;
    margin: 0;
    padding: 3px;
    border: none;
    border-radius: 4px;
    background-color: transparent;

    line-height: 0;

    & .thumbnail-loader {
      position: absolute;
      inset: 0;
      display: flex;
      align-items: center;
      justify-content: center;
      background-color: rgba(255, 255, 255, 0.75);
    }

    img {
      background-color: var(--border-color);
    }
  }

  @media (hover: hover) {
    & .card-thumbnails button {
      &:hover {
        border: 1px solid var(--border-color);

        & img {
          border-radius: 2px;
        }
      }
    }
  }

  & .card-thumbnails button.active {
    pointer-events: none;
    border: 1px solid var(--primary-color);
  }

  & .card-thumbnails button.active img {
    border-radius: 2px;
  }

  & .card-thumbnails button img {
    aspect-ratio: 1 / 1;
    object-fit: cover;
    width: 100%;
    height: 100%;
    border-radius: 4px;
  }

  & .card-headline {
    & h2 {
      color: var(--secondary-color);
    }
  }

  &.content-alignment-left {
    & .card-headline {
      & h2 {
        text-align: left;
      }
    }

    .value {
      justify-content: flex-start;

      &.text,
      &.long_text {
        text-align: left;
      }

      &.long_text {
        &.wrap {
          white-space: pre-wrap;
          min-width: 0px;
        }
      }
    }

    & .spanholder--label {
      text-align: left;

      &.spanholder--label {
      }
    }

    & .spanholder {
      text-align: left;
    }
  }

  &.content-alignment-center {
    & .card-headline {
      & h2 {
        text-align: center;
      }
    }

    .value {
      justify-content: center;

      &.text,
      &.long_text {
        text-align: center;
      }

      &.long_text {
        &.wrap {
          white-space: pre-wrap;
          min-width: 0px;
        }
      }
    }

    & .spanholder--label {
      text-align: center;

      &.spanholder--label {
      }
    }

    & .spanholder {
      text-align: center;
    }
  }

  &.content-alignment-right {
    & .card-headline {
      & h2 {
        text-align: right;
      }
    }

    .value {
      justify-content: flex-end;

      &.text,
      &.long_text {
        text-align: right;
      }

      &.long_text {
        &.wrap {
          white-space: pre-wrap;
          min-width: 0px;
        }
      }
    }

    & .spanholder--label {
      text-align: right;

      &.spanholder--label {
      }
    }

    & .spanholder {
      text-align: right;
    }
  }
}

.grid .tags,
.grid .dropdown {
  flex-wrap: wrap;
}

.grid .status,
.grid .tags,
.grid .dropdown,
.grid .group,
.grid .timeline,
.grid .vote,
.grid .week {
  gap: 4px;

  & strong {
    padding: 0.5em 1.2em;
    background-color: var(--secondary-color);
    border-radius: 1.5em;
    font-size: 0.7em;
    font-weight: normal;
    white-space: nowrap;
    color: #fff;
  }
}

.grid .status {
  margin-top: 0.75em;
}

& .empty {
  display: none;
}

.card-image[data-format='16:9_LARGE'],
.card-image[data-format='16:9_MEDIUM'],
.card-image[data-format='16:9_SMALL'] {
  aspect-ratio: 16 / 9;
}

.card-image[data-format='4:3_LARGE'],
.card-image[data-format='4:3_MEDIUM'],
.card-image[data-format='4:3_SMALL'] {
  aspect-ratio: 4 / 3;
}

.card-image[data-format='1:1_LARGE'],
.card-image[data-format='1:1_MEDIUM'],
.card-image[data-format='1:1_SMALL'] {
  aspect-ratio: 1;
}

/* ---------------------------
  EVENTS
--------------------------- */

.events {
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  justify-content: flex-start;
  align-items: flex-start;
  gap: var(--events-item-gap);

  &.content-alignment-left {
    & .events-item {
      text-align: left;
    }
  }

  &.content-alignment-center {
    & .events-item {
      text-align: center;

      & .events-preview {
        & .events-meta {
          justify-content: center;
        }

        & .events-headline {
          justify-content: center;

          & h2 {
            flex: 0;

            white-space: nowrap;
          }
        }
      }
    }
  }

  &.content-alignment-right {
    & .events-header {
      flex-direction: row-reverse;
    }

    & .events-item {
      text-align: right;

      & .events-preview {
        & .events-meta {
          flex-direction: row-reverse;
          justify-content: flex-start;
        }

        & .events-headline {
          flex-direction: row-reverse;
        }
      }
    }
  }

  & .events-item {
    overflow: hidden;
    position: relative;
    padding: var(--events-item-padding);
    width: calc(100% - (var(--events-item-padding) * 2));
    border: 1px solid var(--border-color);
    border-radius: var(--events-item-border-radius);
    background-color: #fff; /*var(--widget-background-color);*/

    &.events-item--no_padding {
      width: 100%;

      & .SkeletonImage,
      & .events-image,
      & .events-image img {
        border-radius: 0;
      }

      & .events-preview {
        padding: 25px;
      }
    }

    & .SkeletonImage {
      overflow: hidden;
      max-width: 350px;
      /*min-width: 250px;*/
      border-radius: calc(var(--events-item-border-radius) * 0.65);
    }

    & .events-image {
      overflow: hidden;
      max-width: 350px;
      /*min-width: 250px;*/

      line-height: 0;

      & img {
        /*object-fit: cover;*/
        width: 100%;
        height: auto; /*100%;*/
        border-radius: calc(var(--events-item-border-radius) * 0.65);
      }

      &[data-format='1:1_SMALL'],
      &[data-format='1:1_MEDIUM'],
      &[data-format='1:1_LARGE'] {
        aspect-ratio: 1;
      }

      &[data-format='16:9_SMALL'],
      &[data-format='16:9_MEDIUM'],
      &[data-format='16:9_LARGE'] {
        aspect-ratio: 16 / 9;
      }
    }
  }

  & .events-header {
    display: flex;
    flex-wrap: nowrap;
    /*align-items: center;*/
    align-items: stretch;
    gap: 0;
  }

  & .events-preview {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: flex-start;
    gap: 20px;
    flex: 1;
    margin: calc(var(--events-item-padding) * 1.5);
    min-width: calc((100% - var(--events-item-padding) * 2) / 2);
    min-width: 50%;
    /*margin: 35px;
    min-width: calc((100% - 105px) / 2);*/

    & .events-headline {
      width: 100%;

      & h2 {
        flex: 1;
      }
    }

    & .events-meta {
      display: flex;
      flex-direction: row;
      flex-wrap: wrap;
      column-gap: 35px;
      row-gap: 20px;
      /*margin: 20px 0;*/
      width: 100%;

      color: var(--secondary-color);

      & .events-date,
      & .events-time,
      & .events-location {
        & a {
          text-decoration: none;
          color: var(--secondary-color);

          & .events-location--default_ {
            display: block;
          }

          & .events-location--hover_ {
            display: none;
          }

          @media (hover: hover) {
            &:hover {
              color: var(--primary-color);

              & .events-location--default_ {
                display: none;
              }

              & .events-location--hover_ {
                display: block;
              }
            }
          }
        }
      }
    }

    & .events-description {
      color: var(--secondary-color);
    }

    & .LearnMoreButton {
      cursor: pointer;
      overflow: hidden;
      display: inline-block;
      padding: 8px 16px;
      background-color: var(--primary-color);
      border: 1px solid var(--primary-color);
      border-radius: var(--events-item-border-radius);
      max-width: calc(100% - 32px);

      text-overflow: ellipsis;
      text-decoration: none;
      white-space: nowrap;
      color: #fff; /*var(--background-color);*/
    }
  }

  & .events-toggle {
    cursor: pointer;
    z-index: 100;
    position: absolute;
    bottom: 0;
    right: 0;
    padding: 10px 14px 11px 14px;
    background-color: var(--border-color);
    border-top-left-radius: calc(var(--events-item-border-radius) / 2);

    font-size: calc(var(--font-size) * 0.75);
    color: var(--primary-color);

    &.events-toggle--open i {
      transform: rotate(-90deg);
    }
  }

  & .events-content {
    position: relative;
    margin: calc(var(--events-item-padding) * -1);
    margin-top: var(--events-item-padding);
    padding: var(--events-item-padding);
    border-top: 1px solid var(--border-color);

    &:before {
      content: '';
      position: absolute;
      top: 0;
      right: 0;
      bottom: 0;
      left: 0;
      background-color: var(--border-color);
      opacity: 0.15;
    }

    & .value-wrapper {
      & .spanholder {
        & .value,
        & .downloads--list {
          &:not(:empty, .download) {
            margin-top: 0.75em;
          }
        }
      }
    }
  }
}

@media (hover: hover) {
  .events {
    & .events-preview {
      & .LearnMoreButton {
        &:hover {
          background-color: transparent;
          color: var(--primary-color);
        }
      }
    }
  }
}

@media only screen and (max-width: 640px) {
  .events {
    & .events-header {
      flex-direction: column;
      align-items: flex-start;
    }

    & .events-item {
      padding: 0 !important;
      width: 100%;

      &.events-item--no_padding {
        & .events-preview {
          margin: 25px;
        }
      }

      & .events-header {
      }

      & .SkeletonImage,
      & .events-image,
      & .events-image img {
        max-width: 100%;
        border-radius: 0 !important;
      }
    }

    & .events-preview {
      margin: var(--events-item-padding);
      padding: 0 !important;
      min-width: calc(100% - 50px);
      max-width: calc(100% - 50px);

      & .LearnMoreButton {
        width: calc(100% - 32px);

        text-align: center;
      }
    }

    & .events-toggle {
    }

    & .events-content {
      margin: 0;
      padding: var(--events-item-padding);
    }
  }
}

@media only screen and (max-width: 320px) {
  .events {
    & .events-preview {
      & .LearnMoreButton {
        width: calc(100% - 32px);

        text-align: center;
      }
    }
  }
}

.events .value-wrapper {
  position: relative;
}

.events .tags,
.events .dropdown {
  flex-wrap: wrap;
}

.events .status,
.events .tags,
.events .dropdown,
.events .group,
.events .timeline,
.events .vote,
.events .week {
  gap: 4px;

  & strong {
    padding: 0.5em 1.2em;
    background-color: var(--secondary-color);
    border-radius: 1.5em;
    font-size: 0.7em;
    font-weight: normal;
    white-space: nowrap;
    color: #fff;
  }
}

/* ---------------------------
  GLOBAL ICONS
--------------------------- */

.grid,
.table,
.events {
  &.hide_icons {
    .value {
      &:not(.rating) {
        & i {
          display: none;
        }
      }
    }
  }
}

/* ---------------------------
  SPECIALS
--------------------------- */

.value-wrapper {
  display: flex;
  flex-wrap: wrap;
  column-gap: 8px;
}

.spanholder {
  width: 100%;

  & .value {
    &.status {
      display: inline-flex;
      justify-content: center;
      /*margin-top: 0.75em;*/
      padding: 0.5em 1.2em;
      /*min-width: 80px;*/
      border-width: 1px;
      border-style: solid;
      border-radius: 1.5em;
      font-size: 0.7em;
      font-weight: normal;
      white-space: nowrap;

      border-color: var(--primary-color);

      &.nocolor {
        & .status--label {
          color: var(--primary-color);
        }
      }

      &.empty {
        border-color: var(--primary-color);
        background-color: var(--primary-color);
        opacity: 0.1;
      }

      & .status--label {
        color: #fff;
      }
    }
  }
}

.spanholder--label {
  display: flex;
  flex-direction: column;
  gap: 4px;
  margin-top: 0.75em;

  & .value {
    margin-top: 0 !important;
  }

  &.spanholder--inline {
    flex-direction: row;
    gap: 8px;
    width: 100%;

    & strong {
      flex: 1;
    }
  }
}

.table {
  & .spanholder--label {
    &.spanholder--inline {
      align-items: center;
    }
  }
}

.downloads--list {
  list-style: none;
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  row-gap: 0px;
  column-gap: 8px;
  margin: 0;
  padding: 0;

  & .value {
    &.download {
      a {
        flex: 0;
        white-space: nowrap;
      }
    }
  }
}

.downloads--thumbs {
  list-style: none;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  column-gap: 8px;
  margin: 0;
  padding: 0;

  & .value {
    &.download {
      & a {
        display: inline-block;
        width: 30px;
        height: 30px;
        border: none;
        line-height: 0;

        @media (hover: hover) {
          &:hover {
            border: none;
          }
        }
      }
    }
  }
}

.value {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 8px;

  &.rating {
    gap: 1px;
  }

  &.image {
    line-height: 0;

    & img {
      width: 100%;
      height: auto;
    }
  }

  &.download {
    a {
      .download--image {
        overflow: hidden;
        display: flex;
        align-items: center;
        justify-content: center;
        width: inherit;
        height: inherit;
        border: 1px solid transparent;
        border-radius: 4px; /*var(--grid-item-border-radius);*/
      }

      .download--any {
        display: flex;
        align-items: center;
        justify-content: center;
        width: inherit;
        height: inherit;
        border: 1px solid var(--primary-color);
        border-radius: 4px; /*var(--grid-item-border-radius);*/
      }
    }
  }
}
